module.exports = __webpack_public_path__ + "static/media/avatar-image.bf8c8d3d.svg";